module.exports = __webpack_public_path__ + "img/official-1.8ecb721a.png";